import {api} from "../../api/api.js";
import {createEffect} from "effector";

export const sendTicketFx = createEffect()
	.use(async (ticket) => {
		console.log('I am in effect', ticket)
		// return (await api().post('URL', ticket)).data
	})
